import { toLower } from 'lodash-es'

import { IExtendedColDef } from 'app/services/api/agGrid/agGrid'

// find fields with the provided substring and return them
// currently handles a single field substring, but can be used recursively
export const generateColDefsIgnoreFields = (
  colDefs: IExtendedColDef[] | undefined,
  colSubstr: string,
  colDefKey: keyof IExtendedColDef = 'code'
) => {
  return Array.isArray(colDefs)
    ? colDefs
        .filter((colDef) =>
          toLower(colDef[colDefKey]).includes(toLower(colSubstr))
        )
        .map((colDef) => String(colDef[colDefKey]))
    : colDefs
}
